
define('template!webshopQuotationsDetailView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (!q) { ;
__p += '\n<div class="placeholder">' +
((__t = ( loading ? _.i18n('common.loading', null, 'Loading...') : error )) == null ? '' : __t) +
'</div>\n';
 } else { ;
__p += '\n<div class="header">\n    <div class="title">\n        <div class="name">' +
__e( q.productName || q.productCode ) +
'</div>\n        <div class="meta">\n            ' +
((__t = ( _.i18n('webshop.quotations.reference', null, 'Reference') )) == null ? '' : __t) +
' <b>' +
__e( q.reference ) +
'</b> · ' +
((__t = ( q.date )) == null ? '' : __t) +
'\n            · ' +
((__t = ( _.i18n('common.code', null, 'Code') )) == null ? '' : __t) +
': <b>' +
__e( q.productCode ) +
'</b>\n            ';
 if (q.site) { ;
__p += ' · ' +
__e( q.site );
 } ;
__p += '\n        </div>\n    </div>\n    <div class="tools">\n        ';
 if (q.documentUrl) { ;
__p += '\n        <a class="btn-link" href="' +
__e( q.documentUrl ) +
'" target="_blank" rel="noopener"><i class="fa fa-external-link"></i> ' +
((__t = ( _.i18n('webshop.quotations.openDocument', null, 'Open') )) == null ? '' : __t) +
'</a>\n        <a class="btn-link" href="' +
__e( q.pdfUrl ) +
'" target="_blank" rel="noopener"><i class="fa fa-file-pdf-o"></i> PDF</a>\n        ';
 } ;
__p += '\n    </div>\n</div>\n\n<div class="cards">\n    <div class="card">\n        <div class="card-title">' +
((__t = ( _.i18n('common.customer', null, 'Customer') )) == null ? '' : __t) +
'</div>\n        ';
 if (q.customer) { ;
__p += '\n            ';
 if (q.customer.company) { ;
__p += '<div><b>' +
__e( q.customer.company ) +
'</b></div>';
 } ;
__p += '\n            ';
 if (q.customer.name) { ;
__p += '<div>' +
__e( q.customer.name ) +
'</div>';
 } ;
__p += '\n            ';
 if (q.customer.email) { ;
__p += '<div><a href="mailto:' +
__e( q.customer.email ) +
'">' +
__e( q.customer.email ) +
'</a></div>';
 } ;
__p += '\n            ';
 if (q.customer.phone) { ;
__p += '<div>' +
__e( q.customer.phone ) +
'</div>';
 } ;
__p += '\n            ';
 if (q.customer.vatNumber) { ;
__p += '<div>' +
((__t = ( _.i18n('common.vat', null, 'VAT') )) == null ? '' : __t) +
' ' +
__e( q.customer.vatNumber ) +
'</div>';
 } ;
__p += '\n            ';
 if (q.customer.address) { ;
__p += '<div class="address">' +
__e( q.customer.address ) +
'</div>';
 } ;
__p += '\n        ';
 } else { ;
__p += '\n            <div class="muted">' +
((__t = ( _.i18n('webshop.quotations.anonymousHelp', null, 'Anonymous visitor (not logged in when the quotation was generated)') )) == null ? '' : __t) +
'</div>\n        ';
 } ;
__p += '\n    </div>\n    <div class="card">\n        <div class="card-title">' +
((__t = ( _.i18n('webshop.quotations.prices', null, 'Prices (excl. VAT)') )) == null ? '' : __t) +
'</div>\n        <table class="figures">\n            <tr><td>' +
((__t = ( _.i18n('common.quantity', null, 'Quantity') )) == null ? '' : __t) +
'</td><td>' +
((__t = ( q.quantity || '' )) == null ? '' : __t) +
'</td></tr>\n            <tr><td>' +
((__t = ( _.i18n('webshop.quotations.unitPrice', null, 'Unit price') )) == null ? '' : __t) +
'</td><td>' +
((__t = ( q.unitPrice )) == null ? '' : __t) +
'</td></tr>\n            <tr><td>' +
((__t = ( _.i18n('common.total', null, 'Total') )) == null ? '' : __t) +
'</td><td><b>' +
((__t = ( q.totalPrice )) == null ? '' : __t) +
'</b></td></tr>\n            ';
 if (q.expressShipping) { ;
__p += '\n            <tr><td>' +
((__t = ( _.i18n('webshop.quotations.express', null, 'Express shipping') )) == null ? '' : __t) +
'</td><td>' +
((__t = ( q.deliveryCost )) == null ? '' : __t) +
'</td></tr>\n            ';
 } ;
__p += '\n            <tr><td>' +
((__t = ( _.i18n('common.vat', null, 'VAT') )) == null ? '' : __t) +
'</td><td>' +
((__t = ( q.vatRate )) == null ? '' : __t) +
' %</td></tr>\n            ';
 if (q.deliveryDays) { ;
__p += '\n            <tr><td>' +
((__t = ( _.i18n('webshop.quotations.delivery', null, 'Delivery') )) == null ? '' : __t) +
'</td><td>' +
((__t = ( q.deliveryDays )) == null ? '' : __t) +
' ' +
((__t = ( _.i18n('webshop.quotations.workingDays', null, 'working days') )) == null ? '' : __t) +
'</td></tr>\n            ';
 } ;
__p += '\n        </table>\n    </div>\n    ';
 if (q.scales.length) { ;
__p += '\n    <div class="card">\n        <div class="card-title">' +
((__t = ( _.i18n('webshop.quotations.scales', null, 'Price scale') )) == null ? '' : __t) +
'</div>\n        <table class="figures">\n            ';
 _.each(q.scales, function (s) { ;
__p += '\n            <tr class="' +
((__t = ( s.selected ? 'selected' : '' )) == null ? '' : __t) +
'"><td>' +
((__t = ( s.quantity )) == null ? '' : __t) +
'</td><td>' +
((__t = ( s.unitPrice )) == null ? '' : __t) +
'</td></tr>\n            ';
 }); ;
__p += '\n        </table>\n    </div>\n    ';
 } ;
__p += '\n</div>\n\n';
 if (q.documentUrl) { ;
__p += '\n<iframe class="document" src="' +
__e( q.documentUrl ) +
'"></iframe>\n';
 } ;
__p += '\n';
 } ;
__p += '\n';

}
return __p
};});

